export default __webpack_public_path__ + "static/media/travallo_3.f40e7f8c.png";